import { Component, OnInit } from '@angular/core';
import { ActionsSubject } from '@ngrx/store';
import { OPEN_ADD_ADDRESS_POPUP, OpenAddAddressPopup } from 'src/app/store/menu/menu.action';
import { Address } from '../../../../shared/model/authentication/account.model';
import { ModelStore } from 'src/app/shared/model.store';

interface GeoLocationPosition {
  coords: {
    latitude: number,
    longitude: number,
  }
}

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent implements OnInit {

  private isSuccess = false;
  private isAddingAddress = false;
  private showAddAddressPopup = false;
  private address = new Address();
  private stateAbbreviations = [
    'AL','AK','AS','AZ','AR','CA','CO','CT','DE','DC','FM','FL','GA',
    'GU','HI','ID','IL','IN','IA','KS','KY','LA','ME','MH','MD','MA',
    'MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
    'MP','OH','OK','OR','PW','PA','PR','RI','SC','SD','TN','TX','UT',
    'VT','VI','VA','WA','WV','WI','WY'
   ];

  constructor(
    private actionsSubject: ActionsSubject, 
    private modelStore: ModelStore) { }

  ngOnInit() {
    this.actionsSubject.subscribe((data: OpenAddAddressPopup) => {
      if (data.type === OPEN_ADD_ADDRESS_POPUP) {
        this.showAddAddressPopup = true;
        if (window.navigator && window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(
              position => {
                this.address.lat = position.coords.latitude;
                this.address.lng = position.coords.longitude;
              },
              _ => {
                this.address.lat = data.payload.defaultCoordinates.lat;
                this.address.lng = data.payload.defaultCoordinates.lng;
              }
          );
        } else {
          this.address.lat = data.payload.defaultCoordinates.lat;
          this.address.lng = data.payload.defaultCoordinates.lng;
        }
      }
    });
  }

  closePopup() {
    this.isAddingAddress = false;
    this.isSuccess = false;
    this.showAddAddressPopup = false;
  }

  close() {
    this.isAddingAddress = false;
    setTimeout(_ => {
      this.showAddAddressPopup = false;
      this.isSuccess = false;
    }, 3000)
  }

  isAddressValid() {
    return this.address.street && this.isValidUSZip(this.address.zip_code)
      && this.address.city && this.address.state;
  }

  addAddress() {

    if (!this.isAddressValid()) return;

    console.log(this.address);

    this.isAddingAddress = true;

    this.address.address = this.address.city + ', ' + this.address.state + ', US ' + this.address.zip_code; 

    this.modelStore.saveAddress(this.address, 
      () => {
        this.isSuccess = true;
        this.address = new Address();
        this.close();
      },
      (errorMessage) => {
        //Show error dialog
        console.log(errorMessage);
        this.closePopup();
      }
    );
  }

  isValidUSZip(zip: string) {
    return /^\d{5}(-\d{4})?$/.test(zip);
  }

}
